import { Box, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close, CloudUpload, Description } from '@material-ui/icons';
import { Button, StandardDialog, TextField } from '@roc/ui';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

const EXTENSION_REGEX = /.[^.]+$/;

const useStyles = makeStyles(() => ({
  button: {
    minWidth: '10vw',
  },
  top: {
    marginBottom: 10,
  },
  dragArea: {
    border: '2px dotted #427ED1',
    width: '100%',
    backgroundColor: '#EAF4FA',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: 20,
    marginBottom: 10,
    borderRadius: 5,
    cursor: 'pointer',
  },
  icon: {
    minWidth: '20px',
    minHeight: '20px',
    width: '3vw',
    height: '3vw',
    color: '#4B89DA',
  },
  fileContainer: {
    border: '1px solid grey',
    backgroundColor: '#EAF4FA',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px 0',
    borderRadius: 5,
  },

  fileName: {
    marginLeft: 5,
    marginRight: 2,
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export interface FileUpload {
  name: string;
  file?: File;
  taskId: any;
  originalFileName: string;
  fileExtension: string;
  disabled?: boolean;
}

interface IFileUploadModalProps {
  title: string;
  open: boolean;
  top?: React.ReactNode;
  multiple?: boolean;
  disabled?: boolean;
  onClose: () => void;
  onUpload: (uploads: FileUpload[]) => void;
}

interface FileUploadItemProps {
  name: string;
  file: File;
  disabled?: boolean;
  taskId: any;
  originalFileName: string;
  fileExtension: string;
  onSaveName: (name: string) => void;
  onRemove: () => void;
  store: any;
}

export const FileUploadItemWithDownload = (props: FileUploadItemProps) => {
  const classes = useStyles();
  const [isEditing, setIsEditing] = useState(false);
  const [newName, setNewName] = useState(() =>
    props.name.replace(EXTENSION_REGEX, '')
  );

  const onEditName = () => {
    setIsEditing(true);
  };

  const onSaveName = () => {
    const extension = props.name.match(EXTENSION_REGEX)?.[0] ?? '';
    props.onSaveName(newName + extension);
    setIsEditing(false);
  };

  const onRemove = () => {
    props.onRemove();
  };

  return (
    <Box className={classes.fileContainer}>
      <Description />
      {isEditing ? (
        <>
          <TextField
            testId="file-name"
            value={newName}
            fullWidth
            onChange={e => setNewName(e.target.value)}
          />
          <Button testId="save" variant="outlined" onClick={onSaveName}>
            Save
          </Button>
        </>
      ) : (
        <>
          <Typography className={classes.fileName} style={{ cursor: 'pointer' }}>
            <Link key={props.taskId} onClick={() => props.store.downloadTaskFile(props.taskId, props.originalFileName, props.fileExtension)}>{props.name}</Link>
          </Typography>
          {!props.disabled && <Button
            testId="save"
            size="small"
            variant="outlined"
            onClick={onEditName}
          >
            Rename
          </Button>}
        </>
      )}
      {!props.disabled && <Close onClick={onRemove} />}
    </Box>
  );
};